import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.checkSignIn(state.url);
  }

  checkSignIn(url: string): boolean {
    if (this.authService.isAuthenticated() || [
      '/auth/login',
      '/hb',
    ].some(x => url.startsWith(x))) {
      return true;
    }

    this.authService.redirectUrl = url;

    const host = window.location.host;
    this.router.navigate(['/auth/login']);
    return false;
  }
}
